import { jwtDecode } from "jwt-decode"
import type { Uuid } from "@/utils"

type TokenPayload = {
  exp: number
  iat: number
  userId: Uuid
  roles: string[]
}

export default (token: string) => jwtDecode<TokenPayload>(token)
